import { render, staticRenderFns } from "./ResearchDirectionsQuestionMarkIcon.vue?vue&type=template&id=369c2f84"
import script from "./ResearchDirectionsQuestionMarkIcon.vue?vue&type=script&lang=js"
export * from "./ResearchDirectionsQuestionMarkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports